export default __webpack_public_path__ + "static/preschool8-94c34517fd58e9ddccbf640a631655fc.jpg";